import { MdOutlineInventory2, MdOutlineMailOutline } from "react-icons/md";
import { RiDashboardLine } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router-dom";
import { GoProjectSymlink } from "react-icons/go";
import { FaBlog, FaCalculator } from "react-icons/fa";
import { FaUserTie } from "react-icons/fa";

const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      label: "Dashboard",
      icon: <RiDashboardLine size={20} />,
      path: "/admin/dashboard",
    },
    {
      label: "Products",
      icon: <MdOutlineInventory2 size={20} />,
      path: "/admin/products",
    },
    {
      label: "Projects",
      icon: <GoProjectSymlink size={20} />,
      path: "/admin/projects",
    },
    {
      label: "Blogs",
      icon: <FaBlog size={20} />,
      path: "/admin/blogs",
    },
    {
      label: "Carriers",
      icon: <FaUserTie size={20} />,
      path: "/admin/carriers",
    },
    {
      label: "Inquiries",
      icon: <MdOutlineMailOutline size={20} />,
      path: "/admin/inquiries",
    },
    {
      label: "Reviews",
      icon: <RiDashboardLine size={20} />,
      path: "/admin/review",
    },
    {
      label: "Calculator",
      icon: <FaCalculator size={20} />,
      path: "/admin/admin-calculator",
    },
    {
      label: "Calculator-Inquiries",
      icon: <FaCalculator size={20} />,
      path: "/admin/calculatorInquiries",
    },
      {
      label: "Estimate Calculation",
      icon: <FaCalculator size={20} />,
      path: "/admin/admin-estimatecalxulation",
    },
  ];

  const renderItems = () =>
    menuItems.map((item) => {
      const active = location.pathname.startsWith(item.path);
      const isExpanded = !!sidebarOpen;
      return (
        <li key={item.path}>
          <button
            title={!isExpanded ? item.label : ""}
            onClick={() => {
              navigate(item.path);
            }}
            className={`flex items-center w-full h-[44px]  transition-all duration-200
            ${
              active
                ? "bg-primaryAccent text-white shadow-sm"
                : "text-headingText hover:bg-surfaceAccentLight"
            }
            `}
          >
            {/* Icon */}
            <div
              className={`flex-shrink-0 ml-4 flex justify-center transition
              ${active ? "text-white" : "text-descriptionText"}
              `}
            >
              {item.icon}
            </div>

            {/* Label */}
            <span
              className={`text-sm font-medium whitespace-nowrap transition-all duration-200
              ${sidebarOpen ? "opacity-100 pl-2" : "opacity-0 w-0  overflow-hidden"}
              `}
            >
              {item.label}
            </span>
          </button>
        </li>
      );
    });

  return (
    <>
      {/* Desktop Sidebar */}
      <aside
        className={`hidden lg:block bg-surfaceColor border-r  border-borderLight h-screen pt-[70px]
        transition-all duration-300 ease-in-out
        ${sidebarOpen ? "w-[240px]" : "w-[70px]"}
        `}
      >
        <ul className="space-y-2 px-2 py-2">{renderItems()}</ul>
      </aside>

      {/* Mobile Sidebar */}
      <div
        className={`fixed inset-0 z-40 lg:hidden transition
        ${sidebarOpen ? "block" : "hidden"}
        `}
      >
        {/* Overlay */}
        <div
          className="absolute inset-0 bg-black/40 backdrop-blur-sm"
          onClick={() => setSidebarOpen(false)}
        />

        {/* Sidebar panel */}
        <div className="absolute left-0 top-0 w-[240px] h-full bg-surfaceColor border-r border-borderLight pt-[70px] shadow-lg">
          <ul className="space-y-2 px-3 ">{renderItems()}</ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
